import React from 'react'
import type { EventData, GlobalContext } from '../types/events'
import { TrackEventOptions } from '../types/core'

export interface AnalyticsContextType {
  trackEvent(
    eventName: string,
    eventData: EventData,
    options?: TrackEventOptions
  ): void
  setGlobalContext(context: GlobalContext): void
  clearGlobalContext(keys?: string[]): void
  setVehicle(vehicle: {
    year?: string
    make?: string
    model?: string
    engine?: string
    id?: string
  }): void
  clearVehicle(): void
  setUser(userId: string, domain?: string): void
  clearUser(): void
}

export const AnalyticsContext = React.createContext<
  AnalyticsContextType | undefined
>(undefined)
